import { ChangeApplicationContent } from "../value/change-application-content";
import { ErrorMessageObject } from "@pscsrvlab/psc-react-components";

export function changeApplicationContentCustomValidation(
  _value: ChangeApplicationContent,
  _skipOptional: boolean,
): ErrorMessageObject[] {
  return [];
}
